<template>
    <div>
      <div id="controls">
        <label for="focalLength">Фокусное расстояние линзы:</label>
        <input
          type="range"
          id="focalLength"
          min="50"
          max="300"
          v-model="lens.focalLength"
          step="10"
        />
        <span>{{ lens.focalLength }}</span> px
      </div>
      <canvas id="opticsCanvas" ref="canvas"></canvas>
    </div>
  </template>
  
  <script>
  export default {
    name: "OpticalExperiment",
    data() {
      return {
        lens: {
          x: 400,
          y: 200,
          focalLength: 150,
          height: 100,
          width: 20,
          isDragging: false,
        },
        rays: [
          { x: 0, y: 170 },
          { x: 0, y: 200 },
          { x: 0, y: 230 },
        ],
        animationFrameId: null, // Идентификатор анимации
      };
    },
    mounted() {
      const canvas = this.$refs.canvas;
      canvas.width = 800;
      canvas.height = 400;
      this.ctx = canvas.getContext("2d");
  
      // События мыши для перемещения линзы
      canvas.addEventListener("mousedown", this.onMouseDown);
      canvas.addEventListener("mousemove", this.onMouseMove);
      canvas.addEventListener("mouseup", this.onMouseUp);
  
      this.animate();
    },
    beforeUnmount() {
      // Остановка анимации
      cancelAnimationFrame(this.animationFrameId);
    },
    methods: {
      onMouseDown(e) {
        const rect = this.$refs.canvas.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        if (
          Math.abs(mouseX - this.lens.x) < this.lens.width / 2 &&
          Math.abs(mouseY - this.lens.y) < this.lens.height / 2
        ) {
          this.lens.isDragging = true;
        }
      },
      onMouseMove(e) {
        if (this.lens.isDragging) {
          const rect = this.$refs.canvas.getBoundingClientRect();
          this.lens.x = e.clientX - rect.left;
          this.lens.y = e.clientY - rect.top;
        }
      },
      onMouseUp() {
        this.lens.isDragging = false;
      },
      drawLens() {
        const ctx = this.ctx;
        ctx.beginPath();
        ctx.ellipse(
          this.lens.x,
          this.lens.y,
          this.lens.width,
          this.lens.height / 2,
          0,
          0,
          Math.PI * 2
        );
        const gradient = ctx.createRadialGradient(
          this.lens.x,
          this.lens.y,
          this.lens.width / 4,
          this.lens.x,
          this.lens.y,
          this.lens.height / 2
        );
        gradient.addColorStop(0, "rgba(0, 150, 255, 0.8)");
        gradient.addColorStop(1, "rgba(0, 50, 150, 0.5)");
        ctx.fillStyle = gradient;
        ctx.fill();
        ctx.strokeStyle = "rgba(0, 200, 255, 0.8)";
        ctx.lineWidth = 2;
        ctx.stroke();
  
        // Фокусное расстояние
        ctx.font = "14px Arial";
        ctx.fillStyle = "white";
        ctx.fillText(
          `F: ${this.lens.focalLength}px`,
          this.lens.x - 20,
          this.lens.y + this.lens.height / 2 + 20
        );
      },
      drawRays() {
        const ctx = this.ctx;
        this.rays.forEach((ray) => {
          ctx.beginPath();
          ctx.moveTo(ray.x, ray.y);
          if (Math.abs(ray.y - this.lens.y) <= this.lens.height / 2) {
            ctx.lineTo(this.lens.x, ray.y);
            const slope = (this.lens.y - ray.y) / this.lens.focalLength;
            const refractedY = ray.y + slope * (this.$refs.canvas.width - this.lens.x);
            ctx.lineTo(this.$refs.canvas.width, refractedY);
          } else {
            ctx.lineTo(this.$refs.canvas.width, ray.y);
          }
          ctx.strokeStyle = "rgba(255, 255, 100, 0.8)";
          ctx.lineWidth = 2;
          ctx.shadowColor = "yellow";
          ctx.shadowBlur = 10;
          ctx.stroke();
        });
      },
      animate() {
        if (!this.ctx || !this.$refs.canvas) return; // Проверка на наличие canvas
  
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        this.drawLens();
        this.drawRays();
  
        this.animationFrameId = requestAnimationFrame(this.animate); // Сохранение ID анимации
      },
    },
  };
  </script>
  
  <style>
  canvas {
    display: block;
    margin: 20px auto;
    border: 1px solid #333;
    background: radial-gradient(circle, #222 0%, #000 100%);
  }
  
  #controls {
    text-align: center;
    margin: 10px auto;
    font-family: Arial, sans-serif;
    color: rgb(4, 0, 246);
  }
  
  #controls label {
    margin-right: 10px;
  }
  
  input[type="range"] {
    width: 300px;
  }
  </style>
  